<script setup>
import { computed, useSlots } from 'vue'
const props = defineProps({
	accent: {
		type: String,
		default: '#D8D8D8',
	},
	dark: {
		type: Boolean,
		default: false,
	},
	size: {
		type: String,
		default: 'md',
	},
})

const sizeClasses = computed(() => {
	return {
		xs: 'h-7 w-7 text-sm',
		sm: 'h-9 w-9 text-md',
		md: 'h-11 w-11 text-xl',
	}[props.size]
})

const slots = useSlots()

function isLightColor(color) {
	let r, g, b

	if (color.match(/^rgb/)) {
		const rgb = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

		r = rgb[1]
		g = rgb[2]
		b = rgb[3]
	} else {
		const hexColor = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

		r = hexColor >> 16
		g = (hexColor >> 8) & 255
		b = hexColor & 255
	}
	const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

	return hsp > 127.5
}
</script>

<template>
	<div :class="['flex select-none items-center justify-center rounded-full font-semibold uppercase text-black', sizeClasses, isLightColor(accent) || dark ? 'text-crowns-off-black' : 'text-crowns-off-white']" :style="{ background: accent }">
		<template v-if="slots?.default">
			<slot />
		</template>
		<template v-else><img class="p-1.5 md:p-2.5" :src="isLightColor(accent) ? 'https://cdn.papercrowns.com/website/images/logos/papercrowns-icon-black.svg' : 'https://cdn.papercrowns.com/website/images/logos/papercrowns-icon-white.svg'" alt="Paper Crowns Logo" /></template>
	</div>
</template>
